import { useSelector } from "react-redux";
import { ESRState } from "../types/data";
import { Snackbar } from "@mui/material";
import store from "../store";
import React from "react";

export function ErrorMessage() {
	const error = useSelector((state: ESRState) => state.error);
	return (
		<Snackbar
			open={!!error}
			sx={{ maxWidth: "50%", wordBreak: "break-all" }}
			autoHideDuration={10 * 1000}
			onClose={() => {
				store.dispatch({
					type: "SET_ERROR",
					error: null,
				});
			}}
			message={error?.message}
		/>
	);
}
